<div class="w-full bg-sable min-h-screen py-10 px-4">

    <fuse-card class="w-4/5 mx-auto p-8 md:p-12 mb-8 flex flex-col">

        <div class="mb-6">
            <button mat-button type="button" (click)="goToDossiersProjet()" matTooltip="Revenir à la liste des dossiers"
                class="!flex items-center hover:!bg-gray-100 cursor-pointer transition-colors">
                <mat-icon class="mr-2 icon-size-5">arrow_back</mat-icon>
                <span>Retour aux dossiers</span>
            </button>
        </div>

        <div class="bg-uploadBg border-l-4 border-accent p-6 mb-10">
            <div class="flex items-start">
                <div class="flex-shrink-0">
                    <mat-icon class="text-accent">info</mat-icon>
                </div>
                <div class="ml-4">
                    <h3 class="text-lg font-bold text-black">{{ isPreparationMode ? 'Commencez votre projet en
                        préparation' : 'Commencez votre projet en déposant le devis' }}</h3>
                    <p class="text-sm text-black mt-1">
                        {{ isPreparationMode
                        ? 'Vous pouvez déposer votre devis même s’il n’est pas encore signé ou s’il s’agit d’un
                        brouillon. Renseignez également les informations du formulaire afin d’initialiser votre projet'
                        : 'Une fois validé par nos équipes, vous pourrez démarrer les travaux et ajouter tous les autres
                        documents de fin de travaux en une fois (facture, attestation sur l’honneur, rapport COFRAC,
                        etc.).' }}
                    </p>
                    <p class="text-sm text-black mt-2 font-medium">
                        Si vous rencontrez un problème, n’hésitez pas à contacter votre Account Manager.<br>
                        L’équipe ACE Energie
                    </p>
                </div>
            </div>
        </div>

        <div class="mb-10" *ngIf="selectedMandataire">
            <mat-form-field appearance="outline" class="w-full md:w-1/3">
                <mat-label>Nom du partenaire</mat-label>
                <mat-select [formControl]="partnersCtrl" (selectionChange)="onPartnerSelected($event)">
                    <input class="p-2" matInput placeholder="Rechercher..." #selectPartner>
                    <mat-option *ngFor="let partner of partnersList | filterEntities: selectPartner?.value ?? ''"
                        [value]="partner">
                        {{partner.name}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <section class="mb-12">

            <!-- ========================================== -->
            <!-- MODE 1: PRÉPARATION -->
            <!-- ========================================== -->
            <ng-container *ngIf="isPreparationMode">
                <h2 class="text-xl font-bold text-gray-800 mb-2">Informations du projet</h2>
                <p class="text-sm text-gray-500 mb-6">Le champ « Fin des travaux » est obligatoire pour créer le projet.
                </p>

                <div class="bg-white rounded-xl p-2">
                    <div class="bg-gray-50 border border-gray-200 rounded-2xl p-8 shadow-sm">
                        <!-- Keep your exact existing form for Preparation -->
                        <form [formGroup]="projectForm" class="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-0">
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Raison sociale du bénéficiaire</mat-label>
                                <input matInput formControlName="rs" class="rounded-md" />
                                <mat-icon matSuffix>business</mat-icon>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Nom du bénéficiaire</mat-label>
                                <input matInput formControlName="nom" />
                                <mat-icon matSuffix>person</mat-icon>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Prénom du bénéficiaire</mat-label>
                                <input matInput formControlName="prenom" />
                                <mat-icon matSuffix>person</mat-icon>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email" type="email" />
                                <mat-icon matSuffix>email</mat-icon>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Fin des travaux (prévue) *</mat-label>
                                <input matInput [matDatepicker]="pickerPrep"
                                    formControlName="dateTravauxPrevisionnelle" />
                                <mat-datepicker-toggle matSuffix [for]="pickerPrep"></mat-datepicker-toggle>
                                <mat-datepicker #pickerPrep></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Date d’engagement</mat-label>
                                <input matInput [matDatepicker]="engagePickerPrep" formControlName="dateEngagement" />
                                <mat-datepicker-toggle matSuffix [for]="engagePickerPrep"></mat-datepicker-toggle>
                                <mat-datepicker #engagePickerPrep></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="col-span-1 md:col-span-3 w-full">
                                <mat-label>Adresse postale</mat-label>
                                <input formControlName="adresse" matInput [matAutocomplete]="auto"
                                    (click)="showAdressAutocomplete()">
                                <mat-icon matSuffix>location_on</mat-icon>
                                <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedOption($event)">
                                    <mat-option *ngFor="let option of filteredOptions?.features"
                                        [value]="option">{{option.properties.label}}, France</mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Code postal</mat-label>
                                <input matInput formControlName="cp" />
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Ville</mat-label>
                                <input matInput formControlName="ville" />
                            </mat-form-field>
                            <mat-form-field appearance="outline" class="w-full">
                                <mat-label>Téléphone</mat-label>
                                <input matInput formControlName="tel" />
                                <mat-icon matSuffix>phone</mat-icon>
                            </mat-form-field>
                        </form>
                    </div>
                </div>

                <p class="text-sm text-gray-500 mb-6 mt-6">Veuillez télécharger votre devis pour initialiser votre
                    projet</p>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div *ngFor="let card of cards">
                        <app-card-upload [card]="card" (viewFile)="onViewFile($event)"
                            (fileSelected)="onFileSelected($event)"></app-card-upload>
                    </div>
                </div>
            <p class="text-sm text-gray-500 mb-6">
                {{ isPreparationMode
                    ? 'Veuillez télécharger votre devis pour initialiser votre projet'
                    : isAfterWorksOnly
                        ? 'Veuillez déposer ensemble le devis signé, la facture et l’attestation sur l’honneur.'
                        : 'Veuillez déposer votre devis pour initialiser votre projet.' }}
            </p>

                <div class="w-full flex flex-wrap justify-center gap-4 items-start mt-4">
                    <ng-container *ngIf="getSingleFileCard().length > 0">
                        <app-file-card *ngFor="let file of getSingleFileCard()" [cardName]="file.card"
                            [file]="file.files[0]" [fileName]="file.files[0].name"
                            (fileDeleted)="onFileDeleted($event)"></app-file-card>
                    </ng-container>
                    <ng-container *ngIf="getMultipleFileCard().length > 0">
                        <ng-container *ngIf="getMultipleFileCard()[0] as multi">
                            <app-file-card *ngFor="let file of multi.files" [cardName]="multi.card"
                                [fileName]="file.name" [file]="file"
                                (fileDeleted)="onFileDeleted($event)"></app-file-card>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-container>

            <!-- ========================================== -->
            <!-- MODE 2: DEPOT EN LOT (!isPreparationMode)  -->
            <!-- ========================================== -->
            <ng-container *ngIf="!isPreparationMode">
                <div class="flex items-center gap-2 mb-4">
                    <div
                        class="w-8 h-8 rounded-full bg-[#419a8c] text-white flex items-center justify-center font-bold">
                        1</div>
                    <h2 class="text-xl font-bold text-gray-800">Uploadez vos devis</h2>
                </div>
                <p class="text-sm text-gray-500 mb-4 ml-10">Chaque fichier créera un nouveau projet en brouillon à
                    l'étape suivante.</p>

                <div class="border-2 border-dashed border-[#419a8c] rounded-2xl p-12 mb-10 text-center bg-white cursor-pointer hover:bg-gray-50 transition"
                    (click)="multiFileInput.click()" (dragover)="onDragOverBatch($event)" (drop)="onDropBatch($event)">
                    <mat-icon class="text-[#419a8c] icon-size-12 mb-4">cloud_upload</mat-icon>
                    <h3 class="text-2xl font-bold text-gray-900 mb-2">Glissez tous vos devis ici</h3>
                    <p class="text-gray-500 mb-6">(Formats acceptés : PDF, JPG - Max 25 Mo par fichier)</p>
                    <button type="button" mat-flat-button
                        class="!bg-[#419a8c] !text-white !px-8 !py-2 !rounded-full font-bold pointer-events-none">Parcourir
                        mes fichiers</button>
                    <input type="file" #multiFileInput multiple accept=".pdf,.jpg,.jpeg" class="hidden"
                        (change)="onFileInputChangeBatch($event)">
                </div>

                <div *ngIf="draftsArray.length > 0" class="mt-8">
                    <div class="flex items-center justify-between mb-4">
                        <div class="flex items-center gap-3">
                            <div
                                class="w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold">
                                2</div>
                            <h2 class="text-xl font-bold text-gray-800">Vérifiez et complétez vos projets</h2>
                            <span class="bg-gray-900 text-white text-xs font-bold px-3 py-1 rounded-full">{{
                                draftsArray.length }} projet(s) en attente</span>
                        </div>
                        <button mat-button type="button" class="text-red-500 hover:bg-red-50"
                            (click)="clearAllBatchDrafts()">
                            <mat-icon class="text-warn-500 mr-1" svgIcon="heroicons_outline:trash"></mat-icon> Vider la
                            liste
                        </button>
                    </div>

                    <form [formGroup]="batchForm">
                        <div formArrayName="drafts" class="flex flex-col gap-4">
                            <div class="grid grid-cols-12 gap-4 px-4 py-2 text-xs font-bold text-gray-500 uppercase">
                                <div class="col-span-2">Fichier</div>
                                <div class="col-span-2">Fin Prévue *</div>
                                <div class="col-span-2">Date Engagement *</div>
                                <div class="col-span-3">Opérations</div>
                                <div class="col-span-2">Justificatifs annexes</div>
                                <div class="col-span-1 text-center">Action</div>
                            </div>

                            <div *ngFor="let draft of draftsArray.controls; let i = index" [formGroupName]="i"
                                class="grid grid-cols-12 gap-4 items-start bg-white border border-gray-200 rounded-xl p-4 shadow-sm">

                                <div class="col-span-2 flex items-center gap-3 truncate pt-5">
                                    <mat-icon class="text-gray-500">description</mat-icon>
                                    <div class="truncate">
                                        <div class="font-bold text-sm truncate" [title]="draft.get('fileName')?.value">
                                            {{ draft.get('fileName')?.value }}</div>
                                    </div>
                                </div>

                                <div class="col-span-2">
                                    <mat-form-field appearance="outline" class="w-full">
                                        <input matInput [matDatepicker]="finPickerBatch"
                                            formControlName="dateTravauxPrevisionnelle" placeholder="jj/mm/aaaa">
                                        <mat-datepicker-toggle matSuffix [for]="finPickerBatch"></mat-datepicker-toggle>
                                        <mat-datepicker #finPickerBatch></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="col-span-2">
                                    <mat-form-field appearance="outline" class="w-full">
                                        <input matInput [matDatepicker]="engPickerBatch"
                                            formControlName="dateEngagement" placeholder="jj/mm/aaaa">
                                        <mat-datepicker-toggle matSuffix [for]="engPickerBatch"></mat-datepicker-toggle>
                                        <mat-datepicker #engPickerBatch></mat-datepicker>
                                    </mat-form-field>
                                </div>

                                <div class="col-span-3 flex items-start gap-2 min-w-0">

                                    <div class="flex-1 min-w-0 flex flex-col">

                                        <mat-form-field appearance="outline" class="w-full">
                                            <mat-icon matPrefix>search</mat-icon>
                                            <input matInput placeholder="Rechercher..."
                                                formControlName="operationSearch" [matAutocomplete]="opAutoBatch"
                                                [disabled]="!draft.get('dateEngagement')?.value">

                                            <mat-autocomplete #opAutoBatch="matAutocomplete"
                                                panelClass="!overflow-x-auto [&_.mat-option]:!w-max [&_.mat-option]:!min-w-full [&_.mat-option]:!pr-4 [&_.mat-option-text]:!whitespace-nowrap [&_.mat-option-text]:!overflow-visible"
                                                (optionSelected)="onOperationChosenBatch($event.option.value, i)">

                                                <ng-container *ngFor="let group of draft.get('availableGroups')?.value">
                                                    <mat-optgroup
                                                        *ngIf="filteredOperationsForGroupBatch(group, draft.get('operationSearch')?.value, draft.get('showCoupDePouce')?.value).length > 0"
                                                        [label]="group.activityName">

                                                        <mat-option
                                                            *ngFor="let op of filteredOperationsForGroupBatch(group, draft.get('operationSearch')?.value, draft.get('showCoupDePouce')?.value)"
                                                            [value]="op"
                                                            [matTooltip]="op.ceeOperationFiles?.length > 0 ? (op.ceeOperationFiles[0].name + ' : ' + op.label) : op.label">
                                                            <span *ngIf="op?.ceeOperationFiles?.length > 0">{{
                                                                op.ceeOperationFiles[0].name }} :</span>
                                                            {{ op.label }}
                                                        </mat-option>

                                                    </mat-optgroup>
                                                </ng-container>
                                            </mat-autocomplete>
                                        </mat-form-field>

                                        <!-- Selected Tags Display -->
                                        <div class="flex flex-col gap-2 mt-1">
                                            <div *ngFor="let op of draft.get('operations')?.value; let opIdx = index"
                                                class="bg-[#e4f3f0] border border-[#a1d6cc] text-[#1e584f] text-xs px-3 py-1.5 rounded-md flex items-center justify-between gap-2 w-full shadow-sm"
                                                [matTooltip]="op.ceeOperationFiles?.length > 0 ? (op.ceeOperationFiles[0].name + ' : ' + op.label) : op.label">

                                                <!-- FIX: Added flex-1 and min-w-0 here to force the truncation to work! -->
                                                <span class="truncate font-medium flex-1 min-w-0">
                                                    <ng-container *ngIf="op?.ceeOperationFiles?.length > 0">{{
                                                        op.ceeOperationFiles[0].name }} : </ng-container>
                                                    {{ op.label }}
                                                </span>

                                                <mat-icon
                                                    class="icon-size-4 cursor-pointer hover:text-red-500 shrink-0 opacity-70 hover:opacity-100 transition-opacity"
                                                    (click)="removeSelectedOperationBatch(i, opIdx)">close</mat-icon>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- Right Side: Toggle -->
                                    <div class="shrink-0 pt-5">
                                        <mat-slide-toggle formControlName="showCoupDePouce" color="primary"
                                            class="scale-[0.85] origin-right">
                                            <span class="text-xs text-gray-500 font-medium whitespace-nowrap">Coup de
                                                pouce</span>
                                        </mat-slide-toggle>
                                    </div>

                                </div>

                                <div class="col-span-2 pt-5">
                                    <button type="button"
                                        class="text-[#419a8c] text-sm font-bold flex items-center hover:underline"
                                        (click)="triggerAdditionalFileBatch(i)">+ Ajouter document</button>
                                    <input type="file" [id]="'additionalFileInput_' + i" multiple class="hidden"
                                        (change)="onAdditionalFileSelectedBatch($event, i)">
                                    <div class="text-xs text-gray-500 mt-1">{{
                                        draft.get('additionalFiles')?.value?.length || 0 }} fichier(s) joint(s)</div>
                                </div>

                                <div class="col-span-1 flex justify-center pt-4">
                                    <button type="button" class="group p-1" (click)="removeBatchDraft(i)"
                                        matTooltip="Supprimer">
                                        <mat-icon
                                            class="text-gray-400 group-hover:text-red-500 transition-all duration-200 ease-in-out group-hover:scale-110"
                                            svgIcon="heroicons_outline:trash"></mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </ng-container>
        </section>

        <div *ngIf="fileValidationMessages.length > 0"
            class="mb-6 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
            <p class="text-sm font-semibold text-red-700 mb-2">Certains fichiers doivent être corrigés avant le dépôt :
            </p>
            <ul class="list-disc pl-5 space-y-1">
                <li *ngFor="let message of fileValidationMessages" class="text-sm text-red-600">
                    {{ message }}
                </li>
            </ul>
        </div>

        <div class="flex justify-center border-t border-gray-100 pt-8 mt-8">
            <button type="button" (click)="isPreparationMode ? deposeProjectFinancement() : submitBatchProjects()"
                [matTooltip]="isPreparationMode ? getSubmitTooltip() : getBatchSubmitTooltip()"
                [disabled]="isUploading || (selectedMandataire && !selectedPartnerByMandate) || (isPreparationMode ? (projectForm.invalid || isUploadDisabled()) : !isBatchSubmissionValid())"
                class="bg-[#419a8c] hover:bg-[#357d72] text-white font-bold py-3 px-10 rounded-lg transition-colors shadow-md disabled:opacity-50 inline-flex items-center justify-center">

                <mat-icon *ngIf="isPreparationMode" svgIcon="send" class="mr-2 text-white"></mat-icon>
                <mat-icon *ngIf="!isPreparationMode" class="mr-2 text-white">check_circle_outline</mat-icon>
                <span>
                    {{ isPreparationMode ? 'Créer le projet' : (isAfterWorksOnly ? 'Déposer le dossier' : 'Valider le dépôt de ' + draftsArray.length + ' devis')  }}
                </span>
            </button>
        </div>
    </fuse-card>

    <div class="w-4/5 mx-auto" *ngIf="isUploading && hasVerifyDocumentAccess">
        <app-creation-analysis-progress class="w-full" [progressPercent]="draftProgressPercent"
            [statusMessage]="draftProgressMessage"></app-creation-analysis-progress>
    </div>

    <app-project-display-history [rawItems]="rawItems" [showPartnerName]="!selectedPartnerByMandate">
    </app-project-display-history>
</div>
